import React, { useEffect, useState } from "react";
import moment from "moment";
// import Search from "../../../../components/search";
import Button from "../../../../../components/button";
import Pagination from "../../../../../components/tablePagination";
import { useSelector } from "react-redux";
import PayOptionsPopUp from "../../../../../components/payoptionspopup";
import {
  doAPayItForwardPayment,
  giftMediumForAppointment,
  payWithPaypal,
  payWithPaypalCompleted,
  payWithSquareCompleted,
  payWithStripe,
  payWithStripeCompleted,
} from "../../../../../services/client";
import ConfirmCancel from "../../../../admin/appointments/subcomponents/cancelpopup";
import { emptyAllSelectBox, session_id_beg, session_id_end } from "../../../../../utils/helpers";
import CheckPayOptionsPopUp from "../../components/checkpaymentoptions";
import PaymentPrices from "../../../appointment/premiumsessions/practitonerInfo/payment/payment";
import GiftYourMediums from "../../components/giftyourmediums";
import { toast } from "react-toastify";
import PayItForwardPopUp from "../../components/payitforward";
import ZoomLinkPopup from "../../../../medium/appointments/subcomponetnts/zoomlinkpopup";
import FloatingActionMenu from "../../../../medium/appointments/subcomponetnts/floatingActionMenu";
import { useTranslation } from "react-i18next";
import { isRefundStatus } from "../../../../../utils/utils";
import { useDynamicTranslation } from "../../../../../i18n/dynamicContent";
// import { getLink } from "../../../../../utils/helpers";
export default function Completed(props) {
  const { t } = useTranslation("clientSessions");
  const { tc } = useDynamicTranslation(); // session type names from the API
  // Refund labels from the backend ("Refund Processing" / "Refunded"), translated for display only.
  const refundStatusLabel = (status) =>
    status === "Refunded"
      ? t("appointments.paymentStatus.refunded")
      : status === "Refund Processing"
      ? t("appointments.paymentStatus.refundProcessing")
      : tc(status);
  const {
    tableData = [],
    changeHandler,
    onClickHandler,
    tableHeaders = [],
    // filterListAppointments,
    openSurveyLink,
    getPaginationData,
    blinkRequest,
    setFilterValues,
    setSearchValues,
    setCounterStatus
  } = props;
  const { allCompletedCount } = useSelector((state) => state.client);
  const { id } = useSelector(
    (state) => state.user.user
  );
  const [activePay, setActivePay] = useState("");
  const [checkBlink, setcheckBlink] = useState();
  const [active, setActive] = useState({});
  // anchor element of the open "..." actions menu (menu is rendered in a portal)
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState('');
  const [paymentCurrency, setPaymentCurrency] = useState('USD');
  const [paymentType, setPaymentType] = useState("");
  const [paymentstatus, setPaymentstatus] = useState(false);
  const [payItforwardValue, setpayItforwardValue] = useState('');
  const [payItforwardFixPrice, setpayItforwardFixPrice] = useState("")
  const [activeContact, setactiveContact] = useState('');

  useEffect(() => {

    console.log(openSurveyLink, "openSurveyLink");
    checkBlinkType(blinkRequest);
    setTimeout(() => {
      setcheckBlink();
    }, 10000);
  }, [blinkRequest]);
  const checkBlinkType = (blink, index) => {
    if (blink === "givefeedback") {
      setcheckBlink(1);
    }
    if (blink === "paymedium") {
      setcheckBlink(2);
    }
  };
  const payItForwardHandler = () => {
    let appoinmentType;
    if (activePay.session_type == "5") {
      appoinmentType = 'donated'
    } else {
      appoinmentType = 'payafter'
    }
    let body = {
      medium_id: activePay.medium_id,
      appointment_id: activePay.id,
      amount: payItforwardValue,
      appointment_type: appoinmentType
    }
    doAPayItForwardPayment(body).then((data) => {
      if (data.data.status) {
        window.open(data.data.data.approvedUrl, "_self");
        // openWaitingContainer();
      }
    }).catch(() => {

    })
  }
  const openPaymentModal = (item) => {
    setActivePay(item);
    if (item.is_pay_forward) {
      // if (item.payitforward_pricing !== null) {
      //   const cleanString = item.payitforward_pricing.slice(1, -1); // remove the outer quotes
      //   const parsedString = cleanString.replace(/\\/g, ''); // remove backslashes

      //   // Step 2: Parse the cleaned string into an object
      //   let parsedPricing;
      //   try {
      //     parsedPricing = JSON.parse(parsedString);
      //   } catch (error) {
      //     console.error("Error parsing JSON:", error);
      //   }
      //   let priceValue = parsedPricing[item.duration];
        if (item.session_type == 7) {
          setpayItforwardValue(item.amount !== null ? item.amount : '');
          setpayItforwardFixPrice(item.amount !== null ? item.amount : '');
          window.loadModal2("#PayItForwardPopUp", "show");
        } else if (item.session_type == 5) {
          setpayItforwardValue(20);
          setpayItforwardFixPrice(20);
          window.loadModal2("#PayItForwardPopUp", "show");
        
      } else {
        setpayItforwardFixPrice('');
        setpayItforwardValue('');
        window.loadModal2("#PayItForwardPopUp", "show");
      }

      return;
    }
    window.loadModal2("#payoptionspopup", "show");
  };

  const openGiftModalForPrepaid = (item) => {
    setActivePay(item);
    setPaymentAmount('');
    setPaymentstatus(!paymentstatus);
    window.loadModal2("#GiftYourMediums", "show");
  }

  const openPaymentModalIfYouWish = (item) => {
    if (item.is_pay_forward) {
      openPaymentModal(item);
    } else {
      setActivePay(item);
      setPaymentstatus(!paymentstatus);
      window.loadModal2("#GiftYourMediums", "show");
    }
  }
  const runCallback = (type) => {

    console.log(activePay, "")
    let body = {
      id: activePay.id,
      medium_id: activePay.medium_id,
      amount: activePay.amount,
      currency: activePay.currency,
      appointment_type: 'payafter',
      client_id: id,
    };
    if (type === "paypal") {
      payWithPaypalCompleted(body)
        .then((data) => {
          console.log(data.data, "cdqe")
          if (data.data.status) {
            setCounterStatus(true)
            // window.loadModal2("#payoptionspopup", "hide");
            window.open(data.data.data.approvedUrl, "_self");
          }
          else {
            toast.error(data.data.message, {
              position: "top-center",
            });
          }
        })
        .catch(() => { });
    } else if (type === "stripe") {
      payWithStripeCompleted(body)
        .then((data) => {
          if (data.data.status) {
            setCounterStatus(true);
            // window.loadModal2("#payoptionspopup", "hide");
            window.open(data.data.data.approvedUrl, "_self");
          }
          else {
            toast.error(data.data.message, {
              position: "top-center",
            });
          }
        })
        .catch(() => { });
    }
    else {
      payWithSquareCompleted(body)
        .then((data) => {
          if (data.data.status) {
            setCounterStatus(true);
            // window.loadModal2("#payoptionspopup", "hide");
            window.open(data.data.data.approvedUrl, "_self");
          }
          else {
            toast.error(data.data.message, {
              position: "top-center",
            });
          }
        })
        .catch(() => { });
    };
  }
  const handleNoShow = (e, appoinment) => {
    let value = e.target.value;
    if (value === "me") {
      changeHandler(
        e,
        2,
        appoinment.appointmentId,
        appoinment.client_id,
        "client",
        "client_id"
      );
    } else {
      changeHandler(
        e,
        2,
        appoinment.appointmentId,
        appoinment.medium_id,
        "client",
        "medium_id"
      );
    }
  };

  const changeHandlerLocal = (e, type, id, targetId, targetType, targetTypeID) => {
    setActive({ e, type, id, targetId, targetType, targetTypeID })
    window.loadModal2('#ConfirmCancelcompletedclient', 'show');
  }

  const cancelRequest = () => {
    window.loadModal2('#ConfirmCancelcompletedclient', 'hide');
    emptyAllSelectBox()
  }
  const confirmRequest = () => {
    let { e, type, id, targetId, targetType, targetTypeID } = active
    console.log(e, type, id, targetId, targetType, targetTypeID);
    changeHandler(e, type, id, targetId, targetType, targetTypeID)
  }

  const priceCheck = (item) => {
    console.log(item, "item")
    let prices = item.amount
    let cur = item.currency;
    // let prices = item.session_length !== undefined && item.session_length !== "" && item.session_length !== null ? Object.values(
    //   JSON.parse(item.session_length)
    // )[0] : 20
    // let cur = item.session_currency !== "" &&
    //   item.session_currency !== null
    //   ? Object.values(JSON.parse(item.session_currency))[0] !== "" ? Object.values(JSON.parse(item.session_currency))[0] : "USD"
    //   : "USD";
    let price = prices !== "" && prices !== null ? prices : 20
    let currency = cur !== "" && cur !== null ? cur : 'USD'
    return t("appointments.payPrice", { price, currency })
  }
  const paymentMethodHandler = (type) => {

    console.log(activePay, "activePay")

    // Prepaid sessions are already settled, so the gift goes through its own endpoint,
    // which leaves the prepayment transaction untouched. Pay It Forward gifts (medium has
    // Pay It Forward on) also use it: the server sends them to the house Stripe account.
    if (activePay.session_type == 8 || activePay.gift_is_pay_forward) {
      if (!(paymentAmount > 0)) {
        toast.error(t("appointments.amountGreaterThanZero"), {
          position: "top-center",
        });
        return;
      }
      giftMediumForAppointment({
        appointment_id: activePay.id,
        amount: paymentAmount,
        method: type,
      })
        .then((data) => {
          if (data.data.status) {
            window.open(data.data.data.redirectUrl, "_self");
          } else {
            toast.error(data.data.message, {
              position: "top-center",
            });
          }
        })
        .catch(() => { });
      return;
    }

    let body = {
      id: activePay.id,
      medium_id: activePay.medium_id,
      amount: paymentAmount,
      currency: activePay.currency ? activePay.currency : "USD",
      appointment_type: 'pay_if_wish',
      client_id: id,
    };
    if (type === "paypal") {
      payWithPaypalCompleted(body)
        .then((data) => {
          if (data.data.status) {
            // setCounterStatus(true)
            // window.loadModal2("#payoptionspopup", "hide");
            // setCounterStatus(true)
            window.open(data.data.data.approvedUrl, "_self");
            // window.loadModal2('#GiftYourMediums', "hide");

          }
          else {
            toast.error(data.data.message, {
              position: "top-center",
            });
          }
        })
        .catch(() => { });
    } else if (type === "stripe") {
      payWithStripeCompleted(body)
        .then((data) => {
          if (data.data.status) {
            // setCounterStatus(true);
            window.open(data.data.data.approvedUrl, "_self");
            // window.loadModal2("#GiftYourMediums", "hide");
          }
          else {
            toast.error(data.data.message, {
              position: "top-center",
            });
          }
        })
        .catch(() => { });
    }
    else {
      payWithSquareCompleted(body)
        .then((data) => {
          if (data.data.status) {
            // setCounterStatus(true);
            window.open(data.data.data.approvedUrl, "_self");
            // window.loadModal2("#GiftYourMediums", "hide");
          }
          else {
            toast.error(data.data.message, {
              position: "top-center",
            });
          }
        })
        .catch(() => { });
    };
  }
  const changesubmissionIssue = (e, appoinment) => {
    let value = e.target.value;
    console.log(value, "value")
    if (value === "no-show") {


      changeHandlerLocal(
        e,
        2,
        appoinment.appointmentId,
        appoinment.medium_id,
        "client",
        "medium_id"
      );

    }
    else if (value === "mail") {
      window.open("mailto:mailto:concerns@verysoul.com")
    }
  }

  const openZoomLinkPopup = (item) => {
    window.loadModal2("#ZoomLinkPopup", "show")
    setactiveContact(item)
  }
  return (
    <>
      <div className="d-flex justify-content-end gap-10 flex-wrap">
        {/* <Search callApi={filterListAppointments} list={filterList} /> */}
      </div>
      <div className="table-box-medium admin-appoi" style={{ overflow: "visible" }}>
        <div className="appt-table-scroll" style={{ overflowX: "scroll", width: "100%" }}>
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              {React.Children.toArray(
                tableHeaders.map((item) => <th>{item.labelKey ? t("appointments.table." + item.labelKey, { defaultValue: item.title }) : item.title}</th>)
              )}
            </tr>
            {tableData.length > 0 ? (
              tableData.map((appoinment, index) => (
                <>
                  {appoinment.transaction_status != 1 && appoinment.session_type == 8 ? <></> :
                    <tr className="innr">
                      <td>{session_id_beg + appoinment.id + session_id_end}</td>
                      <td>
                        <span className="capitalize">
                          {" "}
                          {appoinment.medium_name}
                        </span>
                      </td>
                      <td style={{ whiteSpace: "normal", wordBreak: "break-word", minWidth: 160, maxWidth: 220 }}>{tc(appoinment.session_name)}</td>
                      <td>
                        {appoinment.session_type === "5" || appoinment.session_type === "3"
                          ? t("appointments.sessionTypes.free")
                          : appoinment.session_type === "7"
                            ? t("appointments.sessionTypes.payAfter")
                            : appoinment.session_type === "8"
                              ? t("appointments.sessionTypes.prePay")
                              : ""}
                      </td>
                  <td>
                    <div style={{ fontWeight: '500' }}>{appoinment.date}</div>
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '2px' }}>{appoinment.time}</div>
                  </td>

                      {/* <td>
                    <select
                      onChange={(e) => handleNoShow(e, appoinment)}
                      className="appointment-select-box"
                    >
                      <option selected disabled>
                        Select
                      </option>

                      <option value={"me"}>{"No Show By Me"}</option>
                      <option value={"other"}>{"No Show By Other"}</option>
                    </select>
                  </td> */}
                      <td>
                       {
                        appoinment.survey_status_type == 1 && appoinment.survey_link == null &&
                        (appoinment.session_type == 7 || appoinment.session_type == 8) ? (
                          <div className="color-d5a67b d-flex align-items-center height-45">
                            {t("appointments.survey.notApplicable")}
                          </div>
                        ) : appoinment.survey_link !== "" &&
                          appoinment.survey_status === "completed" ? (
                          <div className="color-d5a67b d-flex align-items-center height-45">
                            {t("appointments.survey.completed")}
                          </div>
                        ) : (
                          <Button
                            status={0}
                            onClick={(e) => openSurveyLink(appoinment.survey_link)}
                            type="button"
                            className={`survey-status-btn survey-btn-fit ${
                              appoinment.survey_count < 1
                                ? "w-130"
                                : "w-150"
                            } ${
                              checkBlink === 1 && index === 0 ? "alerts-border" : ""
                            }`}
                            title={`${
                              appoinment.survey_count < 1
                                ? t("appointments.survey.takeSurvey")
                                : t("appointments.survey.updateFeedback")
                            }`}
                          />
                        )
                      }
                      </td>
                      <td>
                        {" "}
                        {appoinment.session_type !== "5" && appoinment.session_type !== "3" ? (
                          appoinment.amount !== "0" && appoinment.payment_status !== "Waived" && !isRefundStatus(appoinment.payment_status) ? (
                            appoinment.transaction_status === null ||
                              appoinment.transaction_status === 0 ? (
                              <Button
                                status={0}
                                onClick={() => openPaymentModal(appoinment)}
                                type="button"
                                className={`resend-btn w-150 ${checkBlink === 2 && index === 0
                                  ? "alerts-border"
                                  : ""
                                  }`}
                                title={appoinment.is_pay_forward ? t("appointments.pay") : priceCheck(appoinment)}
                              />
                            ) : appoinment.can_gift_medium ? (
                              <Button
                                status={0}
                                onClick={() => openGiftModalForPrepaid(appoinment)}
                                type="button"
                                className="resend-btn w-150"
                                title={t("giftYourMedium.title")}
                              />
                            ) : (
                              <span className="color-d5a67b ml-5">{" "}{appoinment.is_medium_gifted ? t("appointments.paymentStatus.paidAndGifted") : t("appointments.paymentStatus.paid")}</span>
                            )
                          ) :
                            (
                              <span className="color-d5a67b ml-5">{appoinment.payment_status == "Waived" ? t("appointments.paymentStatus.waived") :  isRefundStatus(appoinment.payment_status) ? refundStatusLabel(appoinment.payment_status) : t("appointments.paymentStatus.paid")}</span>
                            )
                        ) :

                          appoinment.display_button ?

                            <Button
                              status={0}
                              onClick={() => openPaymentModalIfYouWish(appoinment)}
                              type="button"
                              className={`resend-btn w-150 ${checkBlink === 2 && index === 0
                                ? "alerts-border"
                                : ""
                                }`}
                              title={t("appointments.payIfYouWish")}
                            />
                            :
                            appoinment.transaction_status === null ||
                              appoinment.transaction_status === 0 ?
                              <span className="color-d5a67b ml-5"> {t("appointments.paymentStatus.free")}</span>
                              :
                              <span className="color-d5a67b ml-5"> {t("appointments.paymentStatus.paid")} </span>

                        }

                      </td>

                      {/* <td className="dot-image">
                        <img
                          onClick={(e) =>
                            onClickHandler(e, appoinment.appointmentId, "completed")
                          }
                          src="../images/Unionblck.png"
                          className={`pointer dot-image-inside`}
                          alt="dots"
                        />
                        {appoinment.status && (
                          <div className="approve-btn-1 approve-btn z-index-1">
                            <span
                              className="w-100"
                              onClick={(e) => {
                                changeHandlerLocal(
                                  e,
                                  2,
                                  appoinment.appointmentId,
                                  appoinment.medium_id,
                                  "client",
                                  "medium_id"
                                );

                              }}
                            >
                              No Show
                            </span>
                          </div>
                        )}
                      </td> */}
                      <td>
                        <select
                          onChange={(e) => changesubmissionIssue(e, appoinment, index)}

                          className="appointment-select-box"
                        >
                          <option value="" selected disabled>
                            {t("appointments.select")}
                          </option>
                          {appoinment.is_no_show && <option
                            value={'no-show'}
                          >
                            {t("appointments.noShow")}
                          </option>}




                        </select>
                      </td>
                      <td className="dot-image">
                        <img
                          onClick={(e) => {
                            setMenuAnchor(appoinment.status ? null : e.currentTarget);
                            onClickHandler(e, appoinment.appointmentId, "completed");
                          }}
                          src="../images/Unionblck.png"
                          className="pointer dot-image-inside"
                          alt="dots"
                        />
                        {appoinment.status && (
                          <FloatingActionMenu anchorEl={menuAnchor} className="approve-btn-1 approve-btn">
                          {(appoinment.meeting_link !== 'NULL' && appoinment.meeting_link !== ''&& appoinment.is_zoom_link == "1") &&   <span className="w-100 anchor-white ">
                              <a className="width-80px d-inline-block" onClick={() => openZoomLinkPopup(appoinment)}
                                href={`javascript:void();`}>
                                {t("appointments.findZoom")}
                              </a>
                            </span>}
                          </FloatingActionMenu>
                        )}
                      </td>
                    </tr>
                  }
                </>
              ))
            ) : (
              <tr>
                <td colSpan={20} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>{t("appointments.noAppointments")}</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
                </div>
        <Pagination
          rowsPerPageOptions={[5, 10, 25]}
          count={allCompletedCount}
          activeTab={"completed"}
          getPaginationData={getPaginationData}
        />
      </div>

      <ConfirmCancel
        deleteUser={confirmRequest}
        cancelRequest={cancelRequest}
        id={'ConfirmCancelcompletedclient'}
      />
      {/* Rendered outside .appt-table-scroll (z-index:1 stacking context) so the backdrop does not cover it */}
      <PayOptionsPopUp activePay={activePay} from="appointments" runCallback={runCallback} />
      <CheckPayOptionsPopUp activePay={activePay} setPaymentType={setPaymentType} />
      <GiftYourMediums
        activePay={activePay}
        paymentMethodHandler={paymentMethodHandler}
        setPaymentAmount={setPaymentAmount}
        setPaymentCurrency={setPaymentCurrency}
        paymentstatus={paymentstatus}
      />
      <PayItForwardPopUp
        activePay={activePay}
        paymentMethodHandler={payItForwardHandler}
        setpayItforwardValue={setpayItforwardValue}
        setPaymentCurrency={setPaymentCurrency}
        payItforwardFixPrice={payItforwardFixPrice}
        paymentstatus={paymentstatus}
        payItforwardValue={payItforwardValue}
      />
      <ZoomLinkPopup
        activeContact={activeContact}
      />
    </>
  );
}
